import { styled } from "@styles";
import { ArrowCircleRight } from "@untitled-ui/icons-react";

export const Header = styled("div", {
  display: "flex",
  width: "100%",
  padding: "$24px ",
  borderBottom: "1px solid $neutral20",
  marginBottom: "$100px",
});

export const HeaderContainer = styled("div", {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  maxWidth: "1275px",
  margin: "0 auto",
});

export const LogoContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "$12px",
});

export const ArrowIcon = styled(ArrowCircleRight, {
  width: "$24px !important",
  height: "$24px !important",
});
